/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme) {
  return {
    mode: theme?.customization?.navType,
    contrastThreshold: 2.5,
    common: {
      black: theme.colors?.darkPaper,
    },
    primary: {
      light: theme.colors?.primaryLight,
      200: theme.colors?.primary200,
      main: theme.colors?.primaryMain,
      800: theme.colors?.primary800,
      dark: theme.colors?.primaryDark,
    },
    secondary: {
      light: theme.colors?.secondaryLight,
      200: theme.colors?.secondary200,
      main: theme.colors?.secondaryMain,
      800: theme.colors?.secondary800,
      dark: theme.colors?.secondaryDark,
    },
    tertiary: {
      light: theme.colors?.tertiaryLight,
      main: theme.colors?.tertiaryMain,
      dark: theme.colors?.tertiaryDark,
    },
    error: {
      light: theme.colors?.errorLight,
      main: theme.colors?.errorMain,
      dark: theme.colors?.errorDark,
    },
    info: {
      light: theme.colors?.infoLight,
      main: theme.colors?.infoMain,
      dark: theme.colors?.infoDark,
    },
    green: {
      light: theme.colors?.greenLight,
      main: theme.colors?.greenMain,
      dark: theme.colors?.greenDark,
    },
    orange: {
      light: theme.colors?.orangeLight,
      main: theme.colors?.orangeMain,
      dark: theme.colors?.orangeDark,
    },
    warning: {
      light: theme.colors?.warningLight,
      main: theme.colors?.warningMain,
      dark: theme.colors?.warningDark,
    },
    success: {
      light: theme.colors?.successLight,
      200: theme.colors?.success200,
      main: theme.colors?.successMain,
      dark: theme.colors?.successDark,
    },
    grey: {
      50: theme.colors?.grey50,
      100: theme.colors?.grey100,
      500: theme.darkTextSecondary,
      600: theme.heading,
      700: theme.darkTextPrimary,
      900: theme.textDark,
    },
    skill: {
      10: theme.colors?.skill10,
      20: theme.colors?.skill20,
      30: theme.colors?.skill30,
      40: theme.colors?.skill40,
      50: theme.colors?.skill50,
    },

    blue: {
      light: theme.colors?.blueLight,
      200: theme.colors?.blue200,
      main: theme.colors?.blueMain,
      800: theme.colors?.blue800,
      dark: theme.colors?.blueDark,
    },

    red: {
      light: theme.colors?.redLight,
      200: theme.colors?.red200,
      main: theme.colors?.redMain,
      800: theme.colors?.red800,
      dark: theme.colors?.redDark,
    },

    dark: {
      light: theme.colors?.darkTextPrimary,
      main: theme.colors?.darkLevel1,
      dark: theme.colors?.darkLevel2,
      700: theme.colors?.darkLevel5,
      800: theme.colors?.darkBackground,
      900: theme.colors?.darkPaper,
    },
    card: {
      main: theme.colors?.cardMain,
      dark: theme.colors?.cardDark,
    },
    text: {
      primary: theme.darkTextPrimary,
      secondary: theme.darkTextSecondary,
      dark: theme.textDark,
      hint: theme.colors?.grey100,
      Subtitle: theme.colors?.grey500,
    },
    background: {
      paper: theme.paper,
      secondaryPaper: theme.colors?.secondaryPaper,
      default: theme.backgroundDefault,
    },
  };
}
